import { InjuriesFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsInterfaces";
import { BonusTransfer } from "Store/interfaces/CompanyTransferSpecifications";
import { BooleanFormType } from "Store/interfaces/FormTypes";

export interface CarProductDetailsFormValues extends InjuriesFormValues {
  bonus: string;
  mortgagee?: BooleanFormType;
  bonusPreOwnership: BonusTransfer;
  automaticallyPopulated: boolean;
}

export enum CarOwner {
  UNSELECTED = "unselected",
  MYSELF = "me",
  PARTNER = "partner",
  GUARDIAN = "guardian",
  LEASING = "leasing",
  OTHER = "other",
}

export enum DamageCountRecentYears {
  NONE = "0",
  ONE = "1",
  TWO_OR_MORE = "2",
}
